import { makeStyles } from '@material-ui/core'

export const useFieldStyles = makeStyles((theme) => ({
  fieldBox: {
    display: 'flex',
    flexDirection: 'column',

    '&:hover': {
      color: theme.palette.primary.main,
      BorderColor: theme.palette.primary.main,

      '& .MuiInputBase-root:before': {
        borderBottomColor: theme.palette.primary.main,
      },
    },

    '&.error': {
      color: theme.palette.error.light,
      BorderColor: theme.palette.error.light,

      '& .MuiInputBase-root:before': {
        borderBottomColor: theme.palette.error.light,
      },
    },
  },

  fieldLabel: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',

    '& + .MuiInput-formControl': {
      marginTop: 0,
    },
  },

  fieldInputBox: {},

  fieldErrorMessage: {
    color: theme.palette.error.light,
    BorderColor: theme.palette.error.light,
  },
}))
